// TODO: Implement in a later session (UC-12/UC-13/UC-21/UC-24 - version list, PDF viewer, exports, diff).
export function ArchivePage() {
  return (
    <section>
      <h1>Archive</h1>
      <p>The version archive is built in a later session, over publication.ts and artifacts.ts.</p>
    </section>
  );
}
